// extracted by mini-css-extract-plugin
export default {"select":"ChartsSection_select__sCILq","chartCard":"ChartsSection_chartCard__UpYwB"};